var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path4, _rect10, _rect11, _path5, _circle, _path6, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoDataSecondarysvgrIcon = function SvgNoDataSecondarysvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 231 232",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noDataSecondary_svgrIcon_svg__a)",
    d: "M177.037 169.611c-36.588 43.605-81.291 36.468-108.788 13.396-45.113-37.855-47.835-81.596-24.18-109.787 50.066-59.667 90.774-48.604 126.458-18.662 18.885 15.846 6.606 41.216 6.51 67.449-.088 24.289 18.25 25.855 0 47.604",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAFF",
    d: "M37.93 170.538c-6.323 0-11.45-5.126-11.45-11.45V89.834c0-6.323 5.127-11.45 11.45-11.45h150.816c6.323 0 11.45 5.127 11.45 11.45v69.254c0 6.324-5.127 11.45-11.45 11.45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noDataSecondary_svgrIcon_svg__b)",
    d: "M37.93 170.538c-6.323 0-11.45-5.126-11.45-11.45V89.834c0-6.323 5.127-11.45 11.45-11.45h150.816c6.323 0 11.45 5.127 11.45 11.45v69.254c0 6.324-5.127 11.45-11.45 11.45z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72.028,
    height: 38.857,
    x: 39.192,
    y: 113.339,
    fill: "url(#noDataSecondary_svgrIcon_svg__c)",
    rx: 5.232
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72.028,
    height: 38.857,
    x: 39.192,
    y: 113.339,
    fill: "#F6F8FD",
    rx: 5.232
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 66.732,
    height: 21.185,
    x: 121.812,
    y: 94.272,
    fill: "url(#noDataSecondary_svgrIcon_svg__d)",
    rx: 5.232
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 66.732,
    height: 21.185,
    x: 121.812,
    y: 94.272,
    fill: "#F6F8FD",
    rx: 5.232
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 66.732,
    height: 21.185,
    x: 121.812,
    y: 121.812,
    fill: "url(#noDataSecondary_svgrIcon_svg__e)",
    rx: 5.232
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 66.732,
    height: 21.185,
    x: 121.812,
    y: 121.812,
    fill: "#F6F8FD",
    rx: 5.232
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 39.962,
    height: 3.959,
    x: 121.813,
    y: 149.075,
    fill: "#F6F8FD",
    rx: 1.979
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 39.962,
    height: 3.959,
    fill: "#F6F8FD",
    rx: 1.979,
    transform: "matrix(1 0 0 -1 39.192 98.231)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 47.666,
    height: 3.959,
    fill: "#F6F8FD",
    rx: 1.979,
    transform: "matrix(1 0 0 -1 39.192 106.706)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0CBDF",
    d: "M131.843 71.032a.469.469 0 0 1 .064.934zm-.87.993a.468.468 0 0 1-.054-.934zm-2.754-.831a.467.467 0 1 1 .017.936zm-1.794.941a.468.468 0 0 1 .012-.936zm-2.692-1.043a.468.468 0 1 1-.064.934zm-1.88.769a.468.468 0 0 1 .106-.93zm-2.558-1.347a.467.467 0 0 1-.186.918zm-1.982.489a.468.468 0 0 1 .251-.902zm-2.246-1.772a.468.468 0 1 1-.369.86zm-2.046.029a.468.468 0 0 1 .464-.814zm-1.68-2.325a.468.468 0 1 1-.614.707zm-1.942-.627a.468.468 0 1 1 .709-.61zm-.78-2.763a.467.467 0 1 1-.82.451zM107 62.305a.469.469 0 0 1 .868-.35zm.067-2.878a.468.468 0 0 1-.909.22zm-1.277-1.59a.467.467 0 1 1 .923-.154zm.597-2.82a.468.468 0 0 1-.933.078zm-1.048-1.749a.468.468 0 0 1 .935-.04zm.879-2.742a.467.467 0 1 1-.936.001zm-.919-1.824a.468.468 0 0 1 .936.017zm1.012-2.693a.468.468 0 1 1-.936-.034zm-.864-1.85a.467.467 0 1 1 .935.039zm1.051-2.683a.468.468 0 0 1-.936-.04zm-.863-1.85a.468.468 0 1 1 .935.034zm1.02-2.691a.468.468 0 1 1-.936-.023zm25.252 35.031q-.472.032-.934.059l-.054-.934q.456-.026.924-.059zm-3.671.164q-.93.017-1.811.005l.012-.936q.866.012 1.782-.005zm-4.567-.104a40 40 0 0 1-1.816-.165l.106-.93q.856.098 1.774.162zm-4.56-.594a26 26 0 0 1-1.796-.43l.251-.901q.824.229 1.731.413zm-4.411-1.341a17 17 0 0 1-1.677-.831l.464-.814q.74.422 1.582.785zm-3.971-2.45a13 13 0 0 1-1.328-1.333l.709-.61q.562.653 1.233 1.238zm-2.928-3.645a16 16 0 0 1-.799-1.692l.868-.35q.333.829.751 1.59zm-1.641-4.348a25 25 0 0 1-.368-1.81l.923-.154q.148.895.354 1.743zm-.704-4.553a46 46 0 0 1-.115-1.827l.935-.04q.04.91.113 1.79zm-.172-4.568q0-.902.017-1.825l.936.017q-.017.916-.017 1.807zm.093-4.552q.033-.9.072-1.816l.935.039q-.04.914-.071 1.811zm.187-4.539q.039-.9.073-1.81l.935.034-.072 1.816zm.157-4.524q.012-.452.019-.906l.936.017q-.008.456-.019.911z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 48.437,
    height: 15.261,
    fill: "url(#noDataSecondary_svgrIcon_svg__f)",
    rx: 4.396,
    transform: "matrix(-1 0 0 1 129.998 39.191)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 61.885,
    height: 19.498,
    x: 75.205,
    y: 24.362,
    fill: "url(#noDataSecondary_svgrIcon_svg__g)",
    rx: 5.616
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#noDataSecondary_svgrIcon_svg__h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14.405,
    d: "m207.585 123.161-32.208-34.997"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159.734,
    cy: 70.602,
    r: 27.315,
    fill: "url(#noDataSecondary_svgrIcon_svg__i)",
    stroke: "url(#noDataSecondary_svgrIcon_svg__j)",
    strokeWidth: 6.174,
    transform: "rotate(-131.5 159.734 70.602)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0CBDF",
    d: "M58.71 189.553a.585.585 0 0 1 .154 1.16zm-33.198-41.555a.584.584 0 1 1-.396-1.1zm-3.472 1.222a.585.585 0 0 1 .887.762zm-.457 2.63a.585.585 0 0 1-.997-.611zm-2.647 2.688a.585.585 0 1 1 1.083.442zm.293 2.65a.584.584 0 1 1-1.117-.347zm-1.992 3.209a.585.585 0 0 1 1.15.213zm.81 2.54a.585.585 0 0 1-1.163-.125zm-1.337 3.53a.585.585 0 0 1 1.17-.015zm1.296 2.329a.584.584 0 1 1-1.164.112zm-.564 3.733a.584.584 0 1 1 1.138-.271zm1.791 1.971a.585.585 0 0 1-1.105.384zm.377 3.758a.584.584 0 1 1 1.03-.556zm2.25 1.426a.585.585 0 0 1-.96.669zm1.394 3.499a.585.585 0 0 1 .832-.822zm2.556.741a.584.584 0 1 1-.737.908zm2.298 3.002a.585.585 0 1 1 .59-1.009zm2.655.073a.584.584 0 1 1-.496 1.059zm2.919 2.409a.586.586 0 0 1 .365-1.111zm2.606-.46a.585.585 0 0 1-.29 1.134zm3.277 1.87a.585.585 0 0 1 .187-1.155zm2.529-.84a.585.585 0 0 1-.127 1.163zm3.5 1.433a.585.585 0 0 1 .049-1.169zm2.417-1.117a.585.585 0 0 1-.004 1.17zm3.602 1.086a.586.586 0 0 1-.057-1.169zm2.354-1.322a.584.584 0 1 1 .092 1.165zm3.662.81a.585.585 0 0 1-.138-1.161zm-31.148-43.05q-.465 0-.969.18l-.396-1.1c.447-.162.904-.25 1.365-.25zm-3.554 2.164a14.4 14.4 0 0 0-1.344 1.868l-.997-.611c.46-.75.947-1.429 1.454-2.019zm-2.908 4.998q-.43 1.053-.79 2.208l-1.117-.347q.374-1.202.824-2.303zm-1.632 5.63q-.212 1.142-.34 2.327l-1.163-.125a32 32 0 0 1 .353-2.415zm-.507 5.842q.013 1.169.127 2.344l-1.165.112a29 29 0 0 1-.132-2.441zm.7 5.806q.27 1.134.654 2.242l-1.106.384a25 25 0 0 1-.686-2.355zm2.06 5.444q.546 1.016 1.22 1.982l-.96.669a22 22 0 0 1-1.29-2.095zm3.446 4.659a21 21 0 0 0 1.724 1.563l-.737.908a23 23 0 0 1-1.82-1.649zm4.613 3.556q.978.572 2.064 1.082l-.496 1.059a27 27 0 0 1-2.159-1.132zm5.348 2.38q1.076.355 2.24.651L36 190.082a36 36 0 0 1-2.317-.674zm5.705 1.366a45 45 0 0 0 2.342.315l-.127 1.163a48 48 0 0 1-2.402-.323zm5.89.579q1.155.049 2.369.052l-.004 1.17a63 63 0 0 1-2.413-.053zm5.914-.031q1.18-.057 2.41-.153l.093 1.165q-1.248.099-2.446.157zm5.935-.504q.605-.072 1.22-.154l.153 1.16q-.623.083-1.235.155z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.752,
    cy: 187.624,
    r: 3.505,
    stroke: "#C0CBDF",
    strokeWidth: 1.17,
    transform: "rotate(65 64.752 187.624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__a",
    x1: 39.278,
    x2: 181.766,
    y1: 151.593,
    y2: 106.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__c",
    x1: 39.192,
    x2: 111.22,
    y1: 139.525,
    y2: 139.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__d",
    x1: 121.812,
    x2: 188.544,
    y1: 108.548,
    y2: 108.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__e",
    x1: 121.812,
    x2: 188.544,
    y1: 136.089,
    y2: 136.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__f",
    x1: 0,
    x2: 110.69,
    y1: 10.284,
    y2: -15.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__g",
    x1: 75.205,
    x2: 137.09,
    y1: 37.502,
    y2: 37.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__h",
    x1: 187.303,
    x2: 227.166,
    y1: 94.968,
    y2: 139.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD3E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__i",
    x1: 151.131,
    x2: 170.225,
    y1: 48.145,
    y2: 77.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noDataSecondary_svgrIcon_svg__j",
    x1: 150.641,
    x2: 160.799,
    y1: 45.159,
    y2: 100.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD3E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "noDataSecondary_svgrIcon_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-83.14997 -81.03223 78.79397 -80.85321 170.537 159.416)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F2"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataSecondarysvgrIcon);
export default ForwardRef;